var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "visitornav", class: _vm.classObj }, [
    _c(
      "div",
      {
        ref: "headwidth",
        staticClass: "nav_head",
        style: { width: _vm.boxWidth },
      },
      [
        _c("div", { staticClass: "left" }, [
          _c("div", { staticClass: "pr50" }, [_vm._t("title")], 2),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pt50" }, [_vm._t("main")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "main_bottom" }, [_vm._t("bottom")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }